import React, { Component } from 'react';

class BuildFor extends Component {
	
	constructor( props ){
		super( props );

		this.state = {
			buildFor: '',
		}

	}

	checkChanged = (e) => {
		
		let buildFor = [];

		if( this.state.buildFor ) {
			buildFor =  this.state.buildFor;
		}	

		if( e.target.getAttribute('class').indexOf('checked') > -1 ) {
			e.target.setAttribute('class', 'checkbox')
		} else {
			e.target.setAttribute('class', 'checkbox checked')
		}		
		
		let i = buildFor.indexOf(  e.target.getAttribute('data-value') )

		if( i === -1 ) {
			buildFor.push( e.target.getAttribute('data-value') );
		} else {
			buildFor.splice(i, 1);
		}

		this.setState({
			buildFor
		});
		
		this.props.setFilters({
			buildFor
		});

	}

	render() {
		return (
			<div>
				<div className="filter-head">Kategorier: </div>
				<ul className="checkbox-wrapper">
					<li>
						<span data-value="m" className="checkbox" onClick={ this.checkChanged } >
							Herrecykler
						</span>
					</li>
					<li>
						<span data-value="f" className="checkbox" onClick={ this.checkChanged } >
							Damecykler
						</span>
					</li>
					<li>
						<span data-value="k" className="checkbox" onClick={ this.checkChanged } >
							Børnecykler
						</span>
					</li>
					<li>
						<span data-value="e" className="checkbox" onClick={ this.checkChanged } >
							El - Cykler
						</span>
					</li>
				</ul>
			</div>
		)
	}
}

export default BuildFor;


// WEBPACK FOOTER //
// ./src/Reducer/Filters/BuildFor.js